// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stage-cube-cont {
    width: 50%;
    height: 100%;
    top: 0;
    padding-top: 18%;
    margin-left: 0;
    position: absolute;
    
    overflow: hidden;
  }
  
  .cubespinner {
    animation-name: spincube;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-duration: 12s;
    transform-style: preserve-3d;
    transform-origin: 100px 100px 0;
    margin-left: calc(50% - 100px);
  }
  
  .cubespinner div {
    position: absolute;
    width: 200px;
    height: 200px;
    border: 1px solid #ccc;
    background: rgba(255, 255, 255, 0.4);
    text-align: center;
    font-size: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 20px 0px lightyellow;
  }
  
  .cubespinner .face1 {
    transform: translateZ(100px);
    color: #dd0031;
  }
  
  .cubespinner .face2 {
    transform: rotateY(90deg) translateZ(100px);
    color: #f06529;
  }
  
  .cubespinner .face3 {
    transform: rotateY(90deg) rotateX(90deg) translateZ(100px);
    color: #28a4d9;
  }
  
  .cubespinner .face4 {
    transform: rotateY(180deg) rotateZ(90deg) translateZ(100px);
    color: #5ed4f4;
  }
  
  .cubespinner .face5 {
    transform: rotateY(-90deg) rotateZ(90deg) translateZ(100px);
    color: #efd81d;
  }
  
  .cubespinner .face6 {
    transform: rotateX(-90deg) translateZ(100px);
    color: #ec4d28;
  }
  
  @keyframes spincube {
    from, to {
      transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
    }
    16% {
      transform: rotateY(-90deg);
    }
    33% {
      transform: rotateY(-90deg) rotateZ(90deg);
    }
    50% {
      transform: rotateY(-180deg) rotateZ(90deg);
    }
    66% {
      transform: rotateY(-270deg) rotateX(90deg);
    }
    83% {
      transform: rotateX(90deg);
    }
  }
  
`, "",{"version":3,"sources":["webpack://./client/components/HeroSection/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;IACZ,MAAM;IACN,gBAAgB;IAChB,cAAc;IACd,kBAAkB;;IAElB,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,sCAAsC;IACtC,mCAAmC;IACnC,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,2CAA2C;IAC3C,cAAc;EAChB;;EAEA;IACE,0DAA0D;IAC1D,cAAc;EAChB;;EAEA;IACE,2DAA2D;IAC3D,cAAc;EAChB;;EAEA;IACE,2DAA2D;IAC3D,cAAc;EAChB;;EAEA;IACE,4CAA4C;IAC5C,cAAc;EAChB;;EAEA;IACE;MACE,oDAAoD;IACtD;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,yCAAyC;IAC3C;IACA;MACE,0CAA0C;IAC5C;IACA;MACE,0CAA0C;IAC5C;IACA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".stage-cube-cont {\n    width: 50%;\n    height: 100%;\n    top: 0;\n    padding-top: 18%;\n    margin-left: 0;\n    position: absolute;\n    \n    overflow: hidden;\n  }\n  \n  .cubespinner {\n    animation-name: spincube;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite;\n    animation-duration: 12s;\n    transform-style: preserve-3d;\n    transform-origin: 100px 100px 0;\n    margin-left: calc(50% - 100px);\n  }\n  \n  .cubespinner div {\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    border: 1px solid #ccc;\n    background: rgba(255, 255, 255, 0.4);\n    text-align: center;\n    font-size: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 20px 0px lightyellow;\n  }\n  \n  .cubespinner .face1 {\n    transform: translateZ(100px);\n    color: #dd0031;\n  }\n  \n  .cubespinner .face2 {\n    transform: rotateY(90deg) translateZ(100px);\n    color: #f06529;\n  }\n  \n  .cubespinner .face3 {\n    transform: rotateY(90deg) rotateX(90deg) translateZ(100px);\n    color: #28a4d9;\n  }\n  \n  .cubespinner .face4 {\n    transform: rotateY(180deg) rotateZ(90deg) translateZ(100px);\n    color: #5ed4f4;\n  }\n  \n  .cubespinner .face5 {\n    transform: rotateY(-90deg) rotateZ(90deg) translateZ(100px);\n    color: #efd81d;\n  }\n  \n  .cubespinner .face6 {\n    transform: rotateX(-90deg) translateZ(100px);\n    color: #ec4d28;\n  }\n  \n  @keyframes spincube {\n    from, to {\n      transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);\n    }\n    16% {\n      transform: rotateY(-90deg);\n    }\n    33% {\n      transform: rotateY(-90deg) rotateZ(90deg);\n    }\n    50% {\n      transform: rotateY(-180deg) rotateZ(90deg);\n    }\n    66% {\n      transform: rotateY(-270deg) rotateX(90deg);\n    }\n    83% {\n      transform: rotateX(90deg);\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
